// PPE 2.0 (DEV-4849 wave 3): read/create client for the versioned, effective-dated margin guardrail
// config (MarginGuardrailConfigController). Governance/admin-tier — distinct from margin authoring
// (marginPlan/marginCriteria). Create publishes a NEW VERSION that supersedes the prior current row for
// the scope; configs are never edited in place. Every call skips the global forbidden-reload: GETs
// degrade to the seed defaults, and the create WRITE surfaces a 403 inline via the thunk mutation-error
// slice instead of triggering the page-reload interceptor.
import { SKIP_FORBIDDEN } from './httpConfig';

export class MarginGuardrailApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCurrentForCompany() {
    return this.#http.get('/api/margin-guardrail-configs', SKIP_FORBIDDEN);
  }

  async getVersions(channelId) {
    return this.#http.get('/api/margin-guardrail-configs/versions', {
      ...SKIP_FORBIDDEN,
      params: { channelId },
    });
  }

  async createVersion(body) {
    return this.#http.post('/api/margin-guardrail-configs', body, SKIP_FORBIDDEN);
  }

  // DEV-4977/MC-10: per-scope concession-budget caps vs their COMPUTED consumed $ (never persisted —
  // summed server-side from approved concession requests against the cap parsed out of the scope's
  // ConcessionBudgetsJson). Consumed is always 0 until MC-12 lands the approved-concession ledger.
  async getConcessionBudgetStatus(channelId) {
    return this.#http.get('/api/margin-guardrail-configs/concession-budget-status', {
      ...SKIP_FORBIDDEN,
      params: { channelId },
    });
  }
}
